module.exports = __webpack_public_path__ + "assets/7661193a2ead62f2778d56f6de68e60f.png";